import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";

import {
    popModal,
    fetchModalData,
    updateModalData,
    saveModalData,
    saveTicketModal,
    submitFilesModal,
    submitTicketFormData,
    submitAuditNoteFormData,
} from "../../../store/actions";

import { ActionButton, RegularButton } from "colbi_web_ui/lib/components/inputs";
import { views } from "../../../store";
import { FORM_ACTIONS } from "../../../store/views/FormActions";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";

import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

import styles from "./ModalViewController.module.sass";

const ModalViewController = (props) => {
    const {
        id,
        view,
        title,
        data,
        args,
        status,
        errors,
        pop,
        fetchData,
        updateData,
        saveData,
        saveTicket,
        modalType,
        submitFilesModal,
        submitTicket,
        submitNCAuditNote,
    } = props;

    const { i18n, logout } = useGlobalValue();
    const View = views[view];
    const form = useRef(null);

    const hiddenDiv = useRef(null);

    const scrollToTop = () =>
        hiddenDiv &&
        hiddenDiv.current &&
        hiddenDiv.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });

    const actions = (View.actions || []).map((action) => {
        switch (action) {
            case FORM_ACTIONS.SAVE:
                return (
                    <ActionButton
                        primary
                        key="action-save"
                        type="submit"
                        onClick={() => {
                            if (form.current) {
                                form.current.submit();
                                scrollToTop();
                            }
                        }}
                    >
                        <small>{i18n`Save`}</small>
                    </ActionButton>
                );
            case FORM_ACTIONS.DELETE:
                return (
                    <ActionButton danger key="action-delete">
                        {<small>{i18n`Delete`}</small>}
                    </ActionButton>
                );

            case FORM_ACTIONS.SUBMIT:
                return (
                    <ActionButton
                        primary
                        key="action-save"
                        type="submit"
                        onClick={() => {
                            if (form.current) {
                                form.current.submit();
                                scrollToTop();
                            }
                        }}
                    >
                        <small>{i18n`Submit`}</small>
                    </ActionButton>
                );

            case FORM_ACTIONS.GENERATE:
                return (
                    <ActionButton
                        primary
                        key="action-save"
                        type="submit"
                        onClick={() => {
                            if (form.current) {
                                form.current.submit();
                            }
                        }}
                    >
                        <small>{i18n`Run`}</small>
                    </ActionButton>
                );

            case FORM_ACTIONS.TICKETSUBMITION:
                return (
                    <div key="form-div">
                        <RegularButton
                            key="action-cancel"
                            onClick={() => {
                                logout();
                            }}
                        >
                            <small>{i18n`Logout`}</small>
                        </RegularButton>
                        <ActionButton
                            key="action-save"
                            type="submit"
                            onClick={() => {
                                if (form.current) {
                                    form.current.submit();
                                }
                            }}
                        >
                            <small>{i18n`Confirm`}</small>
                        </ActionButton>
                    </div>
                );

            default:
                return null;
        }
    });

    useEffect(() => {
        if (View && status === "initial") {
            const queries = (View.queries && View.queries(args || {})) || [];
            const mapper = View.dataMapper || [];

            if (queries.length && mapper.length) {
                fetchData({ id, queries, mapper });
            } else {
                updateData({ id, data });
            }
        }
    }, [id, data, View, args, fetchData, updateData, status]);

    return (
        <>
            <header
                className={`${styles["header"]} ${
                    modalType === "freshdesk" ? styles["freshdesk-header"] : ""
                }`}
            >
                <div>
                    <button
                        className={`${styles["close-button"]} ${
                            modalType === "freshdesk" ? styles["button-container"] : ""
                        }`}
                        onClick={() => {
                            pop(id);
                        }}
                    >
                        <Icon name="close" />
                    </button>
                </div>
                <div
                    className={`${
                        modalType === "freshdesk" ? styles["header-title-container"] : ""
                    }`}
                >
                    <h5 className={`${modalType === "freshdesk" ? styles["header-title"] : ""}`}>
                        {title}
                    </h5>
                </div>
                {modalType !== "center" && modalType !== "freshdesk" ? (
                    <div className={styles["actions"]}>{actions}</div>
                ) : null}
            </header>
            <div ref={hiddenDiv} className={styles["hidden-div"]} />
            <main
                className={`${styles["main"]} ${
                    modalType === "freshdesk" ? styles["main-background"] : ""
                }`}
            >
                {modalType !== "freshdesk" ? (
                    <div className={styles["errors-container"]}>
                        {(errors || []).map(({ message }) => (
                            <div className={styles["error"]} key={message}>
                                <small>{i18n`${message}`}</small>
                            </div>
                        ))}
                    </div>
                ) : null}
                {View && (
                    <View
                        {...(data || {})}
                        ref={form}
                        status={status}
                        onChange={(e) => {
                            updateData({
                                id,
                                data: e.target.value,
                            });
                        }}
                        onSave={() => {
                            switch (view) {
                                case "TicketForm":
                                    saveTicket(id);
                                    break;
                                case "FileSubmissionForm":
                                    submitFilesModal(id);
                                    break;
                                case "FreshDeskForm":
                                    submitTicket(id);
                                    break;
                                case "AuditNotesForm":
                                case "AuditNoteFindingHistoryForm":
                                    submitNCAuditNote(id);
                                    break;
                                default:
                                    saveData(id);
                                    break;
                            }
                        }}
                        errors={modalType === "freshdesk" ? errors : []}
                    />
                )}
                {modalType === "center" ? (
                    <div className={`${styles["actions-center"]}`}>{actions}</div>
                ) : null}
            </main>
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        args: (state.modalsData[ownProps.id] || {}).args,
        data: (state.modalsData[ownProps.id] || {}).data,
        status: (state.modalsData[ownProps.id] || {}).status,
        errors: (state.modalsData[ownProps.id] || {}).errors,
    };
};

const mapDispatchToProps = {
    pop: popModal,
    fetchData: fetchModalData,
    updateData: updateModalData,
    saveData: saveModalData,
    saveTicket: saveTicketModal,
    submitFilesModal: submitFilesModal,
    submitTicket: submitTicketFormData,
    submitNCAuditNote: submitAuditNoteFormData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalViewController);
